document.addEventListener('DOMContentLoaded', () => {
	const fv = document.getElementById('js-fv');
	if (!fv) return;

	const bgItems = fv.querySelectorAll('.fv-bg-item');
	const textItems = fv.querySelectorAll('.fv-text');
	const dots = fv.querySelectorAll('.fv-dot');
	const prevBtn = document.getElementById('js-fv-prev');
	const nextBtn = document.getElementById('js-fv-next');

	if (bgItems.length < 2) return;

	let current = 0;
	const autoplayInterval = 5000;
	let timer = null;

	const showSlide = (index) => {
		bgItems[current].classList.remove('is-active');
		textItems[current]?.classList.remove('is-active');
		dots[current]?.classList.remove('is-active');

		current = (index + bgItems.length) % bgItems.length;

		bgItems[current].classList.add('is-active');
		textItems[current]?.classList.add('is-active');
		dots[current]?.classList.add('is-active');
	};

	const startAutoplay = () => {
		timer = setInterval(() => showSlide(current + 1), autoplayInterval);
	};

	const resetAutoplay = () => {
		clearInterval(timer);
		startAutoplay();
	};

	const goToSlide = (index) => {
		showSlide(index);
		resetAutoplay();
	};

	prevBtn?.addEventListener('click', () => goToSlide(current - 1));
	nextBtn?.addEventListener('click', () => goToSlide(current + 1));
	dots.forEach((dot, i) => {
		dot.addEventListener('click', () => goToSlide(i));
	});

	startAutoplay();
});
